import React from 'react';
import { Star } from 'lucide-react';
import { TapeBadge } from './TapeBadge';
export function Testimonials() {
  const reviews = [{
    name: 'Mike D.',
    location: 'Westside',
    quote: 'Thought I had to throw my Weber away. Case showed up and literally resurrected it. Looks like I just bought it.',
    rotation: -2
  }, {
    name: 'Sarah T.',
    location: 'The Heights',
    quote: 'Fast, professional, and the grill is spotless. My husband is actually excited to cook outside again.',
    rotation: 3
  }, {
    name: 'Jason R.',
    location: 'South Park',
    quote: "These guys don't mess around. The 'Full Send' package is worth every penny. 10/10 would recommend.",
    rotation: -1
  }];
  return <section id="reviews" className="relative bg-otter-black py-24" data-id="element-300">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiPgo8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI4IiBmaWxsPSIjMGEwYTBhIi8+CjxwYXRoIGQ9Ik0wIDBMOCA4Wk04IDBMMCA4WiIgc3Ryb2tlPSIjMjIyIiBzdHJva2Utd2lkdGg9IjEiLz4KPC9zdmc+')] opacity-50" data-id="element-301" />

      <div className="container relative z-10 mx-auto px-4" data-id="element-302">
        <div className="mb-16 text-center" data-id="element-303">
          <h2 className="font-display text-6xl tracking-tighter text-otter-bone sm:text-7xl" data-id="element-304">
            WHAT PEOPLE <span className="text-otter-cyan" data-id="element-305">SAY</span>
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-3" data-id="element-306">
          {reviews.map((review, idx) => <div key={idx} className="relative flex flex-col border-4 border-otter-black bg-otter-bone p-8 shadow-brutal-cyan transition-transform hover:z-20 hover:scale-105" style={{
          transform: `rotate(${review.rotation}deg)`
        }} data-id="element-307">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-308">
                <div className="h-8 w-24 bg-otter-cyan/50 backdrop-blur-sm" style={{
              clipPath: 'polygon(5% 0, 95% 5%, 100% 95%, 0 100%)'
            }} data-id="element-309" />
              </div>

              <div className="mb-6 flex gap-1 text-otter-blaze" data-id="element-310">
                {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" size={24} data-id="element-311" />)}
              </div>

              <p className="mb-8 flex-grow font-accent text-2xl leading-relaxed text-otter-black" data-id="element-312">
                "{review.quote}"
              </p>

              <div className="mt-auto border-t-2 border-otter-black/20 pt-4" data-id="element-313">
                <p className="font-display text-xl tracking-wider text-otter-black" data-id="element-314">
                  {review.name}
                </p>
                <p className="font-body text-sm font-bold text-otter-black/60" data-id="element-315">
                  {review.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}